import axios from "axios";
import * as CryptoJs from "crypto-js";
import Config from "../config/config.js";

export const isEmpty = (value) =>
  value === undefined ||
  value == "undefined" ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0) ||
  (typeof value === "string" && value === "0") ||
  (typeof value === "number" && value === 0);

export const GetToken = (key) => {
  if (key) {
    let cookie = ("; " + document.cookie)
      .split(`; ${key}=`)
      .pop()
      .split(";")[0];
    return cookie;
  } else {
    return undefined;
  }
};

export const axiosFunc = async (data) => {
  try {
    let Resp = {};
    let token = localStorage.getItem('adminkey')
    if (data?.params) {
      data.params = { data: EncryptData(data.params) };
    } else if (data?.data) {
      if (!(data?.data instanceof FormData)) {
        data.data = { data: EncryptData(data.data) };
      }
    }
    if (data?.headers) {
      data.headers.Authorization =
        "Bearer " + (token ?? GetToken(Config.userCookieName));
    } else {
      data.headers = {
        Authorization: "Bearer " + (token ?? GetToken(Config.userCookieName)),
      };
    }
    Resp = await axios(data);
    if (Resp?.data) {
      Resp.data =
        typeof DecryptData(Resp.data) == "string" &&
        DecryptData(Resp.data) == ""
          ? Resp.data
          : DecryptData(Resp.data);
    }
    if (data?.url?.includes("/getUserCollection")) {
      console.log("mdshfshfsfsfafa", Resp, DecryptData(Resp.data));
    }
    return Resp;
  } catch (e) {
    return { success: "error", msg: null };
  }
};

export const EncryptData = (data) => {
  if (typeof data == "string") {
    return CryptoJs.AES.encrypt(data, Config.KEY).toString();
  } else {
    return CryptoJs.AES.encrypt(JSON.stringify(data), Config.KEY).toString();
  }
};

export const DecryptData = (data) => {
  try {
    var bytes = CryptoJs.AES.decrypt(data, Config.KEY);

    var decryptedData;
    try {
      decryptedData = JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
    } catch (err) {
      try {
        decryptedData = bytes.toString(CryptoJs.enc.Utf8);
      } catch (dcpterr) {
        return "";
      }
    }
    return decryptedData;
  } catch (error) {
    return "";
  }
};


export const AppenData = (data, secKey=Config.KEY) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
          value.forEach((item) => {
              if (item?.type && item?.size) {
                  // file
                  formData.append(key, item);
              } else {
                  // non-file, encrypt
                  formData.append(key, EncryptData(item, secKey));
              }
          });
      } else {
          if (value?.type && value?.size) {
              // file
              formData.append(key, value);
          } else {
              // non-file, encrypt
              formData.append(key, EncryptData(value, secKey));
          }
      }
  });

  return formData;
};